<template>
    <div class="page-content">
        <h1>User Guide</h1>
        <hr />
        <div class="user-guide">

            <p>
                We have provided a simple guide explaining the dashboards available to you currently with Eligibility. <br />
                From time to time this Guide will be updated as new dashboards are provided.
            </p>

            <h2>
                Download User Guide
            </h2>

            <div>
                <a v-if="user && user.company.hasFeature('LenderUserGuide')" class="download-btn" type="button" href="/user-guides/EligibilityIQ Lender User Guide.pdf" download="EligibilityIQ User Guide">Download PDF</a>
                <a v-else-if="user && user.company.hasFeature('AggregatorUserGuide')" class="download-btn" type="button" href="/user-guides/EligibilityIQ Aggregator User Guide.pdf" download="EligibilityIQ User Guide">Download PDF</a>
                <a v-else></a>
            </div>

        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'UserGuide',
        computed: {
            ...mapGetters(['user'])
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../styles/base';
    @import '../../../node_modules/hd-styles/modules/mixins';

    .page-content {
        max-width: $feed-width;
        margin: 0 auto;
        height: auto;
    }

    .user-guide {
        font-size: 17px;
    }

    .download-btn {
        height: 40px;
        color: white;
        border-radius: 4px;
        background-color: $blue-mid;
        width: 10rem;
        text-align: center;
        padding: 7px;
        text-decoration: unset;
        cursor: default;
        font-weight: 500;
    }

    .download-btn:hover {
        color: white;
        border-radius: 5px;
        background-color: $blue;
    }
</style>
